import { render, staticRenderFns } from "./PointsTable.vue?vue&type=template&id=dfc19d84&"
import script from "./PointsTable.vue?vue&type=script&lang=ts&"
export * from "./PointsTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports